import React, { PureComponent } from 'react';
import Loadable from '../../ui/loading/Loadable.js';
import api from '../../../api/index.js';

import './leasehistory.scss';

export default class extends PureComponent {
	render() {
		let out = "";
		if (this.props.data) {
			let max = null;
			for(let i=0; i < this.props.data.length; i++) {
				let d = this.props.data[i];
				let dt = api.date(d.DateOfChange)
				// if (d.DateOfChange == '0000-00-00')
					// dt = null;
				if ((max === null || api.date(max.DateOfChange) < dt) && (dt < this.props.endDate || dt == null))
					max = d;
			}
			if (max !== null && max.CompanyID !== null) {
					let when = (max.DateOfChange == null) ? '' : <strong>{max.DateOfChange}: </strong>;
					out = <p>{when}Leased from <u>{max.name}</u>.</p>;
			}
		}
		return <Loadable className="LeaseHistory" ready={this.props.data !== false}>
			{out}
			</Loadable>;
	}
}
